__turbopack_context__.v({
  "dropdownFooter": "MobileHeader-module__3V7QEW__dropdownFooter",
  "header": "MobileHeader-module__3V7QEW__header",
  "headerIcon": "MobileHeader-module__3V7QEW__headerIcon",
  "link": "MobileHeader-module__3V7QEW__link",
  "subLink": "MobileHeader-module__3V7QEW__subLink",
});
